import { ButtonMui } from 'src/components/ButtonMui'
import TextFieldMui from 'src/components/TextFieldMui'
import styled from 'styled-components'

export const Wrapper = styled.div`
    padding: 1rem 0.6rem;
    width: 50rem;
    align-items: center;
    justify-content: center;
    @media (max-width: 768px) {
        width: 100%;
    }
`

export const ContainerInventories = styled.div`
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    gap: 0.3rem;
    align-items: center;
    justify-content: center;
    border: 1px solid #000000;
    padding: 1rem;
    margin-bottom: 1rem;
    margin-top: 1rem;
`

export const ContainerWithoutInventories = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 1rem;
`

export const CustomButtonExecute = styled(ButtonMui)`
    width: 5.5rem;
    height: 1.6rem;
`

export const CustomTextField = styled(TextFieldMui)`
    margin: 0 !important;
    width: 22rem !important;

    & input {
        height: 1.5rem !important;
    }
`

export const ContainerText = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`
